import { translate } from 'locales'
import React from 'react'
import { UserProps } from 'context/user/user.types'
import { getInitials } from './utils'
import * as S from './styles'

interface DoctorInfoProps {
  userData: UserProps
  plan: string | null
  compact?: boolean
}

const DoctorInfo = ({ userData, plan, compact }: DoctorInfoProps) => {
  const specialtyNames = (userData.specialties ?? [])
    .map((specialty) => specialty.name)
    .filter(Boolean)
    .join(' · ')

  const meta = [specialtyNames || userData.profile.specialty, plan]
    .filter(Boolean)
    .join(' · ')

  return (
    <S.DoctorInfo style={compact ? { marginTop: 0 } : undefined}>
      <S.DoctorAvatar hasPhoto={Boolean(userData.profile.photo)}>
        {userData.profile.photo ? (
          <img src={userData.profile.photo} alt={userData.name} />
        ) : (
          getInitials(userData.name)
        )}
      </S.DoctorAvatar>

      <div className="doctor-details">
        <span className="doctor-name">{userData.name}</span>

        <span className="doctor-meta">
          {translate('financial.area')}: {meta}
        </span>
      </div>
    </S.DoctorInfo>
  )
}

export default DoctorInfo
